// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/preventivi/:id/duplica-info',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","numero":"string","versione":"number","stato":"string","richiedeAnnullamentoDopoConferma":"boolean","documentiCollegati":{"commessa":"object|null","ordini":"array","proforme":"array"},"mail":{"disponibile":"boolean","motivoNonDisponibile":"string|null","mittente":"object|null","destinatariSuggeriti":"array","destinatariDefault":"array","oggetto":"string","corpo":"string"}}}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/duplica',
    requestBody: '{"modalita":"COME_NUOVA_VERSIONE|COME_BASE","inviaMailAnnullamento":"boolean?","mailDestinatari":"string[]?","mailOggetto":"string?","mailCorpo":"string?"}',
    response: '{"success":true,"data":{"id":"number","numero":"string","annullatoDopoConferma":"boolean","statoOrigine":"string","mailAnnullamento":"object|null"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/preventivi/:id/commesse-cliente',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","numero":"string","descrizione":"string"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/converti',
    requestBody: '{"dataOrdine":"string","commessaIdTarget":"number|null"}',
    response: '{"success":true,"data":{"commessaId":"number","commessaNumero":"string","ordini":[{"id":"number","numero":"string","destinatarioOrdine":"string|null","importoTotale":"number"}]}}'
  },
  {
    method: 'GET',
    endpoint: '/api/preventivi/:id/allegati/:allegatoId/download',
    requestBody: null,
    response: 'file stream'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/registra-firma',
    requestBody: '(multipart)',
    response: '{"success":true}'
  },
  {
    method: 'GET',
    endpoint: '/api/preventivi/:id/firme',
    requestBody: null,
    response: '{"success":true,"data":{"storico":[...]}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/preventivi/:id/stato',
    requestBody: '{"stato":"INVIATO","note":"string"}',
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/preventivi/:id/stato',
    requestBody: '{"stato":"INVIATO","note":"string"}',
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/preventivi/:id',
    requestBody: '{"oggetto":"string?","dataEmissione":"string?","dataValidita":"string?","indirizzoLavori":"string?","codiceIvaDefaultId":"number?","condizionePagamentoId":"number?","condizionePagamentoAccontoId":"number?","percentualeAcconto":"number?","condizionePagamentoExtraAccontoId":"number?","condizionePagamentoExtraSaldoId":"number?","percentualeAccontoExtraAcquirente":"number|null","codiceIvaExtraAcquirenteId":"number|null","commessaId":"number?","clienteRagioneSociale":"string?","clienteNome":"string?","clienteCognome":"string?","clientePartitaIva":"string?","clienteCodiceFiscale":"string?","clienteIndirizzo":"string?","clienteCap":"string?","clienteCitta":"string?","clienteProvincia":"string?","clienteEmail":"string?","clienteTelefono":"string?","note":"string?","condizioniStampa":"string?","scontoGlobaleTipo":"PERCENTUALE|IMPORTO|null","scontoGlobaleValore":"number|null"}',
    response: '{"success":true}'
  },
  {
    method: 'GET',
    endpoint: '/api/preventivi/:id',
    requestBody: null,
    response: '{"success":true,"data":{...}}'
  },
  {
    method: 'GET',
    endpoint: '/api/preventivi/:id/allegati',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string","nomeFile":"string","mimeType":"string|null","dimensione":"number|null","visibileUfficioTecnico":"boolean","stampaConPreventivo":"boolean","uploadedAt":"string","uploadedBy":{"id":"number","nome":"string"}|null}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/acquirenti/:acquirenteId/allegati',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string","nomeFile":"string","mimeType":"string|null","dimensione":"number|null","ivaAgevolata":"boolean","uploadedAt":"string","uploadedBy":{"id":"number","nome":"string"}|null}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/preventivi/:id',
    requestBody: null,
    response: '{"success":true,"data":{...}}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/sync-firma',
    requestBody: '{}',
    response: '{"success":true,"data":{"stato":"string","aggiornato":"boolean","messaggio":"string"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/codici-iva?societaId={id}&attivo=true',
    requestBody: null,
    response: '{"codici":[{"id":"number","codice":"string","descrizione":"string","aliquota":"string","attivo":"boolean"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/pagamenti?societaId={id}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string"}],"condizioni":[{"id":"number","nome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse/:commessaId/acquirenti',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","commessaId":"number","unitaCodice":"string","unitaDescrizione":"string|null","nome":"string|null","cognome":"string|null","email":"string|null","telefono":"string|null"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/preventivi/:id/commesse-cliente',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/preventivi/:id/log',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","azione":"string","dettaglio":"string|null","utenteName":"string","createdAt":"string"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/aggiorna-da-nominativo',
    requestBody: '{}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/ricarica-condizioni-da-sede',
    requestBody: '{}',
    response: '{"success":true,"condizioniStampa":"string|null","info":"string|null"}'
  },
  {
    method: 'PUT',
    endpoint: '/api/preventivi/:id/stato',
    requestBody: '{"stato":"INVIATO|ACCETTATO|RIFIUTATO|SCADUTO|ANNULLATO"}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/ricalcola-totali',
    requestBody: null,
    response: '{"success":true,"data":{"totaleImponibileCliente":"string","totaleIvaCliente":"string","totaleCliente":"string"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/raggruppamenti',
    requestBody: '{"etichetta":"string","livello":"1|2|3","parentId":"number|null","descrizione":"string?"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/raggruppamenti/riordina',
    requestBody: '{"ordini":"[{id,ordine,parentId?}]"}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/righe/riordina',
    requestBody: '{"ordini":"[{id,ordine,raggruppamentoId?}]"}',
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/preventivi/:id/raggruppamenti/:rId',
    requestBody: '{"etichetta":"string"}',
    response: '{"success":true}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/preventivi/:id/raggruppamenti/:rId',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/righe',
    requestBody: '{"tipoRiga":"ARTICOLO|DESCRITTIVA","raggruppamentoId":"number?","descrizione":"string","quantita":"number?","prezzoUnitario":"number?","sconto":"number?"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/righe/:rigaId/imposta-alternativa',
    requestBody: '{"rigaTargetId":"number","etichettaAlternativa":"string|null"}',
    response: '{"success":true,"data":{"alternativaGruppo":"string|null","alternativaScelta":"boolean","etichettaAlternativa":"string|null"}}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/preventivi/:id/righe/:rigaId',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/righe/:rigaId/duplica',
    requestBody: '{"sciogliClusterSeNecessario":"boolean?"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/raggruppamenti/:rId/duplica',
    requestBody: '{}',
    response: '{"success":true,"data":{"id":"number","nRighe":"number","nGruppi":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/righe/:rigaId/scegli-alternativa',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/righe/:rigaId/imposta-alternativa',
    requestBody: '{"rigaTargetId":"null"}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/righe/:rigaId/imposta-alternativa',
    requestBody: '{"rigaTargetId":"number","etichettaAlternativa":"string|null"}',
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/preventivi/:id',
    requestBody: '{"acquirenteId":"number|null"}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/acquirenti/:acquirenteId/allegati',
    requestBody: '{"file":"File","nome":"string","ivaAgevolata":"boolean"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/acquirenti/:acquirenteId/allegati/:allegatoId',
    requestBody: '{"nome":"string?","ivaAgevolata":"boolean?"}',
    response: '{"success":true}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/acquirenti/:acquirenteId/allegati/:allegatoId',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/allegati',
    requestBody: '{"file":"File","nome":"string","visibileUfficioTecnico":"boolean"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/preventivi/:id/allegati/:allegatoId',
    requestBody: '{"nome":"string?","visibileUfficioTecnico":"boolean?","stampaConPreventivo":"boolean?"}',
    response: '{"success":true}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/preventivi/:id/allegati/:allegatoId',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'GET',
    endpoint: '/api/acquirenti/:acquirenteId/allegati/:allegatoId/download',
    requestBody: null,
    response: 'apre file in nuova tab'
  },
  {
    method: 'GET',
    endpoint: '/api/acquirenti/:acquirenteId/allegati/:allegatoId/download',
    requestBody: null,
    response: 'file stream (attachment)'
  },
  {
    method: 'GET',
    endpoint: '/api/preventivi/:id/allegati/:allegatoId/download',
    requestBody: null,
    response: 'file stream (attachment)'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi/:id/genera-firma-digitale',
    requestBody: '{"vista":"APPALTATORE|ACQUIRENTE|undefined","conTotali":"boolean","conAllegati":"boolean"}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
